// extracted by mini-css-extract-plugin
export default {"app":"App_app__GuJBs","app__buttons":"App_app__buttons__Hd3lw","app__person":"App_app__person__UTbHt","app__data-field":"App_app__data-field__SyRlF"};